// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vOkMA","index":"styles_index__1bBYv"};